<template>
    <div class="page container-fluid container-table">
        <particles-bg type="cobweb" :bg="true" num=200 color="#303030" />
        <div class="row vertical-center-row text-center">
            <h1 class="pt-2 pb-3">Escoge un modo para avanzar</h1>
            <div class="card-deck col-sm-8 mx-auto">
                <div class="card">
                    <div class="card-body">
                        <h1 class="card-title"><i class="fas fa-boxes"></i></h1>
                        <h3 class="card-title">Nuestras PC's</h3>
                        <p class="card-text small">Solicita armar tu equipo a partir de nuestras propuestas establecidas.</p>
                        <small class="text-muted h2"><router-link to=""><i class="fas fa-arrow-circle-right"></i></router-link></small>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h1 class="card-title"><i class="fas fa-cogs"></i></h1>
                        <h3 class="card-title">Avanzado</h3>
                        <p class="card-text small">Ten el control de todos los componentes para una PC a tus necesidades.</p>
                        <small class="text-muted h2"><router-link to=""><i class="fas fa-arrow-circle-right"></i></router-link></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Presets',
}
</script>

<style>

.card {
    background-color: transparent !important;
    border: none;
}

</style>